export default __webpack_public_path__ + "static/media/MeterGraph.6c45e84b.svg";